module.exports = __webpack_public_path__ + "static/media/medicinal_cannabis_logo.08d189c7.png";